import React from 'react'
import renderChildUIComponents from './metadata-mapper'
import {observer } from "mobx-react";
import {isArrayLike} from '../../utils/mobx-utils'
import {IObservableArray, observable} from 'mobx'
import {createContext, getParentFromBinding, getAttributeNameFromBinding, splitAttrQName} from '../../utils/metadata-utils'
import * as api from '../../api'
import { AllowSelectionEnum, FlatDomainDataContext, FormBean, IContextObject, IDomainData, IDomainMetadata, isNewObject, IUIComponentDef, IUIRepeatableSectionDef } from '../../datatypes';
import {v4 as uuidv4} from 'uuid';

const {MDBBtn, MDBIcon, MDBInput, MDBCol} = require('mdbreact');


//Wrappers to disable rerenderes, child components observe mobx so receive updates
class PureWrapper extends React.Component {
  shouldComponentUpdate(nextProps: any, nextState: any) {
    return false;
  }
  render() {
    return this.props.children;
  }
}

function isSelectedObject(item:IDomainData){
  return item._selected ;
}


/**
 * Does the bindedList have selected item?
 * 
 * @param bindedList 
 */
function hasSelected (bindedList:IDomainData[]) {
  for(let i=0; i<bindedList.length; i++){
    if(bindedList[i]._selected) return true;
  }
  return false;
}

interface OrderByObject {
    /** sorting domain object name */
    objectName:string|null, 
    /** sorting attr name */
    trigger:string|null
};

export type RepeatableItemContext = {
    _type: 'RepeatableItemContext',
    /** `${listBinding}[${idx}]_` */
    namePrefix:string,
    listBinding:string,
} & FlatDomainDataContext;

interface RepeatableSectionProps {
    metadata:IUIRepeatableSectionDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;
}

export interface RepeatableChildProps {
    metadata:IUIRepeatableSectionDef;
    formBean:FormBean;
    ctx:RepeatableItemContext;
}

interface RepeatableSectionState {
    isReOrder:boolean;
    sortTrigger:OrderByObject;
}

class RepeatableSection extends React.Component<RepeatableSectionProps,RepeatableSectionState> {
    private _unmounted = false;
    private bindedList = observable.array([] as IDomainData[]);
    private itemCtxArray:RepeatableItemContext[] = [];
  
    constructor(props:RepeatableSectionProps) {
        super(props);

        const {metadata, ctx} = this.props;
        // use either sortBy or orderBy. not both.
        const {
                listBinding,
                /** sort domain objects using this attribute value. */
                sortBy, 
                /** use this attribute to store user adjustable sort order */
                orderBy 
              } = metadata;

        this.state = {
            sortTrigger: this.getOrderByAttr(listBinding, sortBy, orderBy),
            isReOrder: false
        }
        // console.debug(`RepeatableSection ctor componentId=${metadata.componentId} type=${metadata.type}`);
        this.populateBindedListAndContext(ctx, listBinding, this.props.metadata);

        // only need to sort once right now, as move up down do swaps so order is maintained
        this.sortBindedList();

        this.initializeSortTrigger(orderBy);
    }

  componentWillUnmount() {
    this._unmounted = true;
  }
  
  /**
   * populate binding list and add new context accordingly
   * @param ctx observable context
   * @param listBinding the name of listBinding in ObjectName.Attribute format
   */
  populateBindedListAndContext = (ctx:FlatDomainDataContext, listBinding:string, metadata:IUIComponentDef) => {
    //   if(!ctx[listBinding]){
    //       console.error(`missing list binding domain data ${listBinding} in ctx. componentId=${metadata.componentId}`,
    //                     Object.keys(ctx), this.props, this.state);
    //       throw Error(`missing list binding domain data ${listBinding} in ctx`);              
    //   }
      // @ts-ignore
    let repeatableList:IObservableArray<IDomainData> = ctx[listBinding]? ctx[listBinding].data : observable([]);
    if(!isArrayLike(repeatableList)){
        console.error(`listBinding ${listBinding} is not array`, ctx[listBinding]);
        throw Error(`listBinding object ${listBinding} is not array`)
    }
    this.bindedList = repeatableList;
    for(let idx=0; idx<this.bindedList.length; idx++) {
      this.addItemContext(this.bindedList[idx], idx);
    }
  }

  /**
   * when orderBy is activated, initialized sort trigger by given it a new order number
   */
  initializeSortTrigger = (orderBy:string) => {
    if(this.bindedList.length == 0 ){
      return;
    }
    if (orderBy) {
      // update the orderBy column with the new order
      this.bindedList.forEach((dataElement, idx) => {
        if (this.state.sortTrigger.objectName == null)
          dataElement[this.state.sortTrigger.trigger!] = idx + 1;
        else
          (dataElement[this.state.sortTrigger.objectName!] as IDomainData)[this.state.sortTrigger.trigger!] = idx + 1;
      });
    }
  }

  /**
   * sort the initial list according to the sortby/orderby props
   */
  sortBindedList = () => {
    if(this.bindedList.length == 0 || !this.state.sortTrigger.objectName){
      return;
    }
    // IObservableArray.replace()
    this.bindedList.replace(this.bindedList.slice().sort(
      //closure allows to use components this.state
      (a:IDomainData, b:IDomainData):number => {
          // @ts-ignore when state.trigger is set?
        let valueA = a[this.state.sortTrigger.objectName!][this.state.sortTrigger.trigger!];
          // @ts-ignore when state.trigger is set?
          let valueB = b[this.state.sortTrigger.objectName!][this.state.sortTrigger.trigger!];

        // return if any of the value is null
        if((valueA == null) && (valueB == null)) return 0;
        else if(valueA == null) return -1;
        else if(valueB == null) return 1;

        if(valueA > valueB) 
            return 1;
        else if (valueA < valueB) 
            return -1;
        else 
            return 0;
      }
    ));
  }

  /**
   * get the objectName and trigger from the [Object.trigger] format in either sortBy or orderBy property
   * @param {*} listBinding repeatable seciton binding object
   * @param {*} sortBy default sorting, no manual reorder. e.g "PaymentHeader.Id"
   * @param {*} orderBy default sorting with manual reorder
   */
  getOrderByAttr = (listBinding:string, sortBy:string, orderBy:string) => {
    if (sortBy && orderBy){
        console.error(`Error in configuration for repeatable component(${listBinding}): should not include both sortBy and orderBy`); 
        throw "Error in configuration for repeatable component: should not include both sortBy and orderBy"
    }

    let fullName = sortBy || orderBy;
    let splitAttrName = splitAttrQName(fullName);
    let orderByObject:OrderByObject = {objectName:null, trigger:"_OrderBy"} // given fake order by attr name to store sorting result
    if (!splitAttrName.objectName || !splitAttrName.attrName){ 
        return orderByObject;
    }

    orderByObject.objectName = splitAttrName.objectName;
    orderByObject.trigger = splitAttrName.attrName

    return orderByObject;
  }

  /**
   * Add new context for each repeatable item to context array
   * @param {*} item - Repeatable Domain Object Data
   * @param {number} idx 
   */
  addItemContext = (item: IDomainData, idx: number) => {
    if(!this.itemCtxArray) this.itemCtxArray = [];
    this.itemCtxArray.push(this.getNewItemCtx(item,idx));
  }
  
  /**
   * Get and return a new context
   * @param {*} item - Repeatable Domain Object Data
   * @param {number} idx 
   */
  getNewItemCtx = (item: IDomainData, idx: number) => {
    const {ctx, metadata} = this.props;
    const {listBinding} = metadata;
    let namePrefix = `${listBinding}[${idx}]_`; // why no use object for structured data ???

    // todo: ctx[listBinding].metaData might not be root domain object !!!
    let itemContext = createContext(ctx[listBinding].metaData, item);
    // console.debug(`createContext`, itemContext);
    
    // @ts-ignore
    let newContext:RepeatableItemContext = {...this.props.ctx,
                                            ...itemContext, // override listBinding domain data
                                            _type:'RepeatableItemContext',
                                            namePrefix:namePrefix,
                                            listBinding // original list binding
                                        };
    return newContext;
  }

  addAnother = async(bindedList:IDomainData[], listBinding:string) => {
    //this is binded list from mobx,
    //any updates here will be pushed to the mobx state
    // todo: listBinding must be child domain object name
    let repeatableData = await api.getEmptyDomainObject(listBinding, this.props.formBean.ClientCode);
    //Make all properties observable before spreading them into the context
    repeatableData = observable.object(repeatableData);

    const {childViewName} = this.props.metadata;
    if(childViewName){
      let newCtx = this.getNewItemCtx(repeatableData, bindedList.length);
      let obj:IContextObject = {
        operation: "Add",
        newCtx: newCtx,
        id: repeatableData.Id
      }

      let callback = (b:boolean) =>{
        if(b){
          this.addItemContext(repeatableData, bindedList.length);
          //this should only be done if the component is still mounted
          if(!this._unmounted)
            bindedList.push(repeatableData);
        }
      };
      this.props.formBean.changeView!(childViewName, obj, callback);
    } else{
      this.addItemContext(repeatableData, bindedList.length);
      //this should only be done if the component is still mounted
      if(!this._unmounted)
        bindedList.push(repeatableData);
    }
  }

  removeObj = async (bindedList:IDomainData[], index:number) => {
    // doing soft delete by updating the deleted flag
    bindedList[index]._deleted = true;
  }

  callChangeSelectionFuncs = async () => {
      // @ts-ignore TODO: is it a bug or useless code?
      if(this.props.onSelectionChange){
          // @ts-ignore
        for(let i=0; i<this.props.onSelectionChange.length; i++){
          // @ts-ignore TODO: we need global busy overlay support for async call
          await Promise.resolve(this.props.onSelectionChange[i]());             
        }
      }
  }
  
  editObj = async (bindedList:IDomainData[], index:number) => {
    const {editChildViewName,listBinding} = this.props.metadata;
    let obj:IContextObject = {
      operation: "Edit",
      newCtx: this.itemCtxArray[index],
      // @ts-ignore
      id: this.itemCtxArray[index].domainDataCtx[listBinding].data.Id as string
    }
    if(editChildViewName) this.props.formBean.changeView!(editChildViewName, obj)
  }

  selectObj = async (bindedList:IDomainData[], index:number, type:AllowSelectionEnum) => {
    let shouldCallChangeSelectionFuncs = false;
    // making _selected as true
    if(type === "SINGLE") {
      bindedList.forEach((o,i) => {
        let oldSelected = o._selected;

        if(i === index) {
          o._selected = true;
        }else {
          o._selected = false;
        }
        if(oldSelected !== o._selected){
          shouldCallChangeSelectionFuncs = true;
        }
      })
    }else if(type === "MULTIPLE"){
      let oldSelected = bindedList[index]._selected;
      bindedList[index]._selected = !bindedList[index]._selected;
      if(oldSelected !== bindedList[index]._selected){
      }
    }
    if(shouldCallChangeSelectionFuncs){
      this.callChangeSelectionFuncs();
    }
  }

  deselectAll = (bindedList:IDomainData[]) => {
    let hasSelectedItems = hasSelected(bindedList);
    bindedList.forEach(item=> item._selected = false );
    if(hasSelectedItems){
      this.callChangeSelectionFuncs();
      this.forceUpdate();
    }
  }

  /**
   * find the next non-deleted object
   * @param currentIndex the current index in the bindedList
   * @param isIncremenIndex is searching upwards or downwards
   */
  findObjectIndex = (bindedList:IDomainData[], currentIndex:number, isIncremenIndex:boolean) => {
    // IE does not support findIndex method
    let firstIndex = -1;
    if (bindedList.length > 0) return firstIndex; // directly return of there's nothing in the list

    if(isIncremenIndex) {
      for(let idx = currentIndex+1; idx < bindedList.length; idx++){
        if (bindedList[idx]._deleted === false){
          firstIndex = idx;
          break;
        }
      }
    }
    else{
      for(let idx = currentIndex-1; idx >= 0; idx--){
        if (bindedList[idx]._deleted === false){
          firstIndex = idx;
          break;
        }
      }
    }

    return firstIndex;
  }

  /**
   * swapping the sorting value for the attribute specify in the orderBy props (sortBy props does not allow manual reordering)
   */
  swapOrderBy = (bindedList:IDomainData[], firstIndex:number, secondIndex:number) => {
    let sortTrigger = this.state.sortTrigger.trigger!;
    let triggerObject = this.state.sortTrigger.objectName!;

    // if the sortTrigger is not in any of the sub-object, then do not need to include objectName when accessing the value
    if (this.state.sortTrigger.objectName == null){
      let order = bindedList[secondIndex][sortTrigger];
      bindedList[secondIndex][sortTrigger] = bindedList[firstIndex][sortTrigger];
      bindedList[firstIndex][sortTrigger] = order;
    }
    else{
      let order = (bindedList[secondIndex][triggerObject] as IDomainData)[sortTrigger];
      (bindedList[secondIndex][triggerObject] as IDomainData)[sortTrigger] = (bindedList[firstIndex][triggerObject] as IDomainData)[sortTrigger];
      (bindedList[firstIndex][triggerObject] as IDomainData)[sortTrigger] = order;
    }
  }

  // swap the two component
  swapObject = (objectList:any[], firstIndex:number, secondIndex:number) => {
    let secondObject = objectList[secondIndex]
    objectList[secondIndex] = objectList[firstIndex];
    objectList[firstIndex] = secondObject;
  }

  sortUp = (bindedList:IDomainData[], index:number) => {
    let previousIndex = this.findObjectIndex(bindedList, index, false);
    if(bindedList.length > 1 && index > 0 && previousIndex != -1)
    {
      this.swapOrderBy(bindedList, index, previousIndex);
      // actually swapping the dataList
      this.swapObject(bindedList, index, previousIndex);
      this.swapObject(this.itemCtxArray, index, previousIndex);
    }
    else return;
  }

  sortDown = async(bindedList:IDomainData[], index:number) => {
    let nextIndex = this.findObjectIndex(bindedList, index, true);
    if(bindedList.length > 1 && index!== bindedList.length-1 && nextIndex != -1)
    {
      this.swapOrderBy(bindedList, index, nextIndex);
      // actually swapping the dataList
      this.swapObject(bindedList, index, nextIndex);
      this.swapObject(this.itemCtxArray, index, nextIndex);
    }
    else return;
  }

  render() {
    const {metadata, formBean} = this.props;
    const {
      listBinding,
      enableUpDown,
      addLabel,
      addIcon,
      editIcon,
      innerWidth,
      allowSelection,
      cssClasses,
      deleteIcon,
      filter,
      enableDeselect,
      deselectLabel,
    } = metadata;

    const callId = uuidv4();
    // console.debug(`RepeatableSection render ${callId} componentId=${metadata.componentId} type=${metadata.type}`);

    // console.log(`render repeatable section ${title}`);
    let repeatableList = this.bindedList;
    let isNewOnly = filter == 'NEW_ONLY';
    let isSelectedOnly = filter == 'SELECTED_ONLY';
    let canDelete = deleteIcon && repeatableList.filter(item => !item._deleted && (!isNewOnly || isNewObject(item)) && (!isSelectedOnly || isSelectedObject(item))).length > 1;
    let canEdit = editIcon ? true : false;

    //TODO: remove once sorting is fully tested
    let canSort = false && enableUpDown && repeatableList.filter(item => !item._deleted && (!isNewOnly || isNewObject(item)) && (!isSelectedOnly || isSelectedObject(item))).length > 1;
    let innerWidthProp = innerWidth ? innerWidth : { xs:"12", sm:"12", md:"12", lg:"12" }; //fallback to default value if innerWidth is not set.

    this.itemCtxArray = []; // create this.ctxArray from this.props.ctx
    let rows = repeatableList.map((item, idx)=> {
      this.addItemContext(item, idx);
      if(item && item._deleted || isNewOnly && !isNewObject(item) || (isSelectedOnly && !isSelectedObject(item))) {
        return null;
      }

      return (
        <MDBCol xs={innerWidthProp.xs} sm={innerWidthProp.sm} md={innerWidthProp.md} lg={innerWidthProp.lg} className={'innerRepeatableSectionDivWrapper'} 
                key={"repeatableSection_" + item._edgeName + item.Id}>
          <div className={'innerRepeatableSectionDiv' + (repeatableList[idx]._selected ? ' highlightSelectedSection' : '')}>

          {canDelete && <MDBIcon id={"repeatable-remove-"+idx} className="repeatableRemove" onClick={() => this.removeObj(repeatableList, idx)} icon={deleteIcon}/>}
          {canEdit && <MDBIcon id={"repeatable-edit-"+idx} className="repeatableEdit" onClick={() => this.editObj(repeatableList, idx)} icon={editIcon}/>} 
          
          { (canSort) &&
          <React.Fragment>
            <MDBIcon id={"repeatable-sortDown-"+idx} className="repeatableSort" onClick={() => this.sortDown(repeatableList, idx)} icon={"angle-down"}/>
            <MDBIcon id={"repeatable-sortUp-"+idx} className="repeatableSort" onClick={() => this.sortUp(repeatableList, idx)} icon={"angle-up"}/>
          </React.Fragment>
          }

          <div className={'repeatableComponentsSectionWrapper'}>
          {allowSelection && allowSelection ==="SINGLE" ?<div className={"repeatableSelectButton"} >
                <MDBInput
                    id={"repeatable-select-radio-"+idx}
                    type={"radio"}
                    checked = {repeatableList[idx]._selected || false}
                    onClick={() => this.selectObj(repeatableList, idx, "SINGLE")}
                    label={" "}
                >
                </MDBInput>
          </div>
          : allowSelection && allowSelection === "MULTIPLE" ?<div className={"repeatableSelectButton"} >
                  <MDBInput
                      id={"repeatable-select-checkbox-"+idx}
                      type='checkbox'
                      filled
                      checked = {repeatableList[idx]._selected || false}
                      onClick={() => this.selectObj(repeatableList, idx, "MULTIPLE")}
                      label={" "}
                  >
                  </MDBInput></div>
          : ''}
          <div className={"repeatableComponents" + (allowSelection && allowSelection !== 'NONE'? ' restrictWidthOfComponentSection' : '')}>
          <PureWrapper key={"aux_" + listBinding + item.Id}>
          {
            renderChildUIComponents({metadata, formBean, ctx: this.itemCtxArray[idx]})
          }

          </PureWrapper>
          </div>
          </div>
          </div>
        </MDBCol>
      );
    });
    if(rows && allowSelection && allowSelection ==="SINGLE" && enableDeselect){ // support single selection for now
      rows.push(
          <MDBCol xs={innerWidthProp.xs} sm={innerWidthProp.sm} md={innerWidthProp.md} lg={innerWidthProp.lg} className={'innerRepeatableSectionDivWrapper'} key={"repeatableSection_last"}>

          <div className={'innerRepeatableSectionDiv'}>
            <div className={'repeatableComponentsSectionWrapper'}>
          <div className={"repeatableSelectButton"} >
                        <MDBInput
                            id={"repeatable-select-radio-deselect"}
                            type={"radio"}
                            checked = {  !hasSelected(repeatableList) }
                            onClick={ ()=> this.deselectAll(repeatableList) }
                            label=" "
                        >
                        </MDBInput>
                  </div>
                <div className={"repeatableComponents" + ' restrictWidthOfComponentSection'}>
                  <span className={"repeatableDeSelect"}>{deselectLabel || 'None of above'}</span>
                </div>
            </div>
          </div>
          </MDBCol>
      );
    }

    let hasAddButton = !!addLabel || !!addIcon;
    let cssClass = cssClasses ? cssClasses : '';
    return (
      //pass all oberservable properties as part of the context
      <React.Fragment>
        <div className={cssClass+" repeatableContent repeatableBox" + ((allowSelection === "SINGLE" || allowSelection === "MULTIPLE") ? " repeatableSectionWithSelect" : "") + (canDelete ? " repeatableSelectShift" : "")}>
          {rows}
        </div>
        <div className={"repeatableAddSection"}>
          {hasAddButton &&
          <MDBBtn className="btn btn-white btn-outline-grey repeatableAdd" onClick={() => this.addAnother(repeatableList, listBinding)}>
            {addIcon && <MDBIcon className={"repeatableAddIcon"} icon={addIcon} />}
            {addLabel}
          </MDBBtn>
          }
        </div>
      </React.Fragment>
    )
  }
}

export default observer(RepeatableSection);
